import React from 'react';
import { SectionLabel } from './SectionLabel';
export function ThePractice() {
  return <section className="py-32 px-6 md:px-12 lg:px-24 max-w-5xl mx-auto border-t border-ink/10" data-id="element-76" data-mp="1w5p9vzislpde">
      <SectionLabel number="01" title="The Office" data-id="element-77" data-mp="2b2g2npxyo2u1" />

      <div className="max-w-3xl font-serif text-xl md:text-2xl lg:text-3xl leading-[1.5] text-ink font-light space-y-6" data-id="element-78" data-mp="2b1y9j26li4qc">
        <p data-id="element-79" data-mp="261sf5e8xy44k">
          You're the most disciplined person in every room. Except this one.
          And you know it.
        </p>

        <p data-id="element-80" data-mp="1dfhds1difz6p">
          The mirror has been telling you. So have the photographs from the
          last event you spoke at.
        </p>

        <p data-id="element-81" data-mp="1s5eww2wl1yp1">
          Bringing that discipline into this room is what we do. Vera is the
          operation.
        </p>
      </div>

      {/* Italic-serif pull quote — the signature treatment from the brand book */}
      <div className="mt-24 flex flex-col items-center text-center" data-id="element-82" data-mp="zlgbwyr9hw24">
        <p className="font-serif italic font-light text-ink text-2xl md:text-3xl tracking-wide" data-id="element-83" data-mp="unoks6yfydyz">
          “Quality as the highest form of status.”
        </p>
        <div className="mt-10 h-px w-16 bg-brass" aria-hidden="true" data-id="element-84" data-mp="1p8h5m06isjob" />
      </div>
    </section>;
}